export enum PatchJobRequestType {
    statusUpdate = 'statusUpdate',
    sourcingStatusUpdate = 'sourcingStatusUpdate',
}
